import { render, staticRenderFns } from "./c-sort-btn.vue?vue&type=template&id=49fe5fb4&scoped=true&"
import script from "./c-sort-btn.vue?vue&type=script&lang=js&"
export * from "./c-sort-btn.vue?vue&type=script&lang=js&"
import style0 from "./c-sort-btn.vue?vue&type=style&index=0&id=49fe5fb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fe5fb4",
  null
  
)

export default component.exports